import pages from '../../data/page';
import { Session } from '../services/Store';

export function usePage() {
    return (page: keyof typeof pages) => {
        Session.setPage(page);
    };
}
